import './PrivacyPolicyPage.scss'

type Props = {}
const PrivacyPolicyPage = (props: Props) => {
    return (
        <div>
            <h1 className="privacy-heading">Privacy Policy</h1>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Incidunt esse quam quibusdam. Fugit, in inventore iste saepe
                voluptas explicabo, doloremque possimus quos quod minus a, modi
                dicta rem sapiente illo.
            </p>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Repellat maiores maxime similique hic enim obcaecati quidem
                eaque itaque quia, fugiat, non sapiente voluptates fugit
                accusamus doloribus placeat quas at rerum?
            </p>
            <p>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Error
                laudantium culpa commodi, numquam nisi quo! Animi quo est, error
                nostrum, numquam minima repellendus quasi dolores fugit nisi
                autem deserunt cumque?Lorem ipsum dolor sit, amet consectetur
                adipisicing elit. Fugiat, aliquam. Debitis provident dolorem
                illum odio nesciunt eum illo. Nostrum vel accusamus debitis
                aliquid tempora! Necessitatibus qui fugit mollitia inventore
                aperiam?
            </p>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores
                tenetur doloremque blanditiis accusamus sit ad placeat numquam
                quibusdam modi repudiandae, eaque quas iusto aspernatur,
                aliquam, quo alias id voluptate a!
            </p>
            <h2 className="privacy-heading">Information Collection and Use</h2>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Pariatur molestias repellendus temporibus sapiente, a magni sed,
                architecto corrupti, laudantium necessitatibus accusantium
                eligendi possimus optio? Porro vel provident explicabo ratione
                fuga.
            </p>
            <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Libero
                repellat quas fugiat cum aliquam. Nulla neque quas incidunt quam
                ducimus illo rem architecto, quidem, eaque eveniet porro
                accusantium et minima?
            </p>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Incidunt repudiandae consectetur dolores iste possimus ipsam
                nam, maxime eum ipsa alias pariatur exercitationem nostrum,
                dignissimos porro quidem libero nihil tempore eligendi.
            </p>
            <ul>
                <li>
                    Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                    Dicta similique, inventore sit ut architecto alias sapiente!
                    Facilis dolores eveniet soluta voluptatem odit sequi ad
                    doloribus nesciunt ipsam! Soluta, quibusdam illum.
                </li>
                <li>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Repellendus assumenda distinctio quas perferendis dicta
                    magnam, eius odit modi. Illo, odio. Quaerat iusto eligendi
                    perferendis natus dolor odit nam, officia fugit!
                </li>
                <li>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Veritatis suscipit vero mollitia illo quisquam corrupti
                    doloremque, impedit ullam vel officia dolorem labore
                    tempore! Omnis non quo adipisci sunt ab hic?
                </li>
                <li>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Molestiae, itaque magni fuga nisi vero, porro illo in alias
                    quas unde quis laudantium, animi ut maxime ratione
                    architecto soluta eveniet facilis!
                </li>
            </ul>
            <h2 className="privacy-heading">Log Data</h2>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam
                vero cum amet voluptate, accusantium doloremque voluptatibus sit
                officiis dolorum mollitia, odio qui vel, est assumenda eius in
                soluta voluptatem? Aperiam. Lorem ipsum dolor sit amet
                consectetur adipisicing elit. Aperiam quaerat quo, a, labore
                perferendis architecto eum fugit omnis quod dolore, repudiandae
                adipisci illum nemo dolores dolor dicta rem culpa vero. Lorem
                ipsum dolor sit amet consectetur adipisicing elit. Placeat illo
                inventore fugit obcaecati, et, sapiente voluptatem dicta culpa
                nemo, debitis alias officiis beatae necessitatibus illum
                laboriosam possimus! Dolorem, et molestias?
            </p>
            <h2 className="privacy-heading">Cookies</h2>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam
                vero cum amet voluptate, accusantium doloremque voluptatibus sit
                officiis dolorum mollitia, odio qui vel, est assumenda eius in
                soluta voluptatem? Aperiam. Lorem ipsum dolor sit amet
                consectetur adipisicing elit. Aperiam quaerat quo, a, labore
                perferendis architecto eum fugit omnis quod dolore, repudiandae
                adipisci illum nemo dolores dolor dicta rem culpa vero.
            </p>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Aperiam
                vero cum amet voluptate, accusantium doloremque voluptatibus sit
                officiis dolorum mollitia, odio qui vel, est assumenda eius in
                soluta voluptatem? Aperiam. Lorem ipsum dolor sit amet
                consectetur adipisicing elit. Aperiam quaerat quo, a, labore
                perferendis architecto eum fugit omnis quod dolore, repudiandae
                adipisci illum nemo dolores dolor dicta rem culpa vero.
            </p>
            <h2 className="privacy-heading">Service Providers</h2>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora
                veniam minima tenetur architecto repudiandae consequuntur,
                pariatur rem beatae molestiae eius ab quas voluptate nesciunt
                numquam magni! Autem eum saepe quidem.
            </p>
            <ul>
                <li>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </li>
                <li>
                    Quo totam vel, at incidunt expedita iusto officia doloribus
                    molestias nisi perspiciatis dolores quod, sequi quis nostrum
                    consequuntur!
                </li>
                <li>Autem voluptatum omnis pariatur.</li>
                <li>
                    Nemo aspernatur sapiente neque quidem incidunt odio impedit
                    doloribus ad, dolore at iste repudiandae?
                </li>
            </ul>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi
                magni neque sapiente aspernatur. Dicta, voluptate facilis!
                Itaque consectetur vero fugiat ab fuga, esse tempora
                perferendis, qui nostrum sint voluptatum vel.
            </p>
            <h2 className="privacy-heading">Security</h2>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Doloremque beatae rem impedit, blanditiis quo enim
                necessitatibus reiciendis, dicta culpa recusandae, mollitia
                itaque aliquam ex cum molestias at? Reiciendis, placeat
                recusandae?Lorem ipsum dolor sit amet consectetur adipisicing
                elit. Impedit nisi fugiat distinctio magni velit obcaecati.
                Esse, doloribus hic. Non, obcaecati veritatis sequi corrupti
                sunt officia quos mollitia sint ex architecto!
            </p>
            <h2 className="privacy-heading">Links to Other Sites</h2>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Doloremque beatae rem impedit, blanditiis quo enim
                necessitatibus reiciendis, dicta culpa recusandae, mollitia
                itaque aliquam ex cum molestias at? Reiciendis, placeat
                recusandae?Lorem ipsum dolor sit amet consectetur adipisicing
                elit. Impedit nisi fugiat distinctio magni velit obcaecati.
                Esse, doloribus hic. Non, obcaecati veritatis sequi corrupti
                sunt officia quos mollitia sint ex architecto!
            </p>
            <h2 className="privacy-heading">Children's Privacy</h2>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Doloremque beatae rem impedit, blanditiis quo enim
                necessitatibus reiciendis, dicta culpa recusandae, mollitia
                itaque aliquam ex cum molestias at? Reiciendis, placeat
                recusandae?Lorem ipsum dolor sit amet consectetur adipisicing
                elit. Impedit nisi fugiat distinctio magni velit obcaecati.
                Esse, doloribus hic. Non, obcaecati veritatis sequi corrupti
                sunt officia quos mollitia sint ex architecto!
            </p>
            <h2 className="privacy-heading">Changes to This Privacy Policy</h2>
            <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Excepturi cumque odit expedita minus temporibus sunt nisi nemo
                ullam nostrum explicabo numquam veniam quia eum quae at quos,
                eaque tempora odio. Lorem ipsum dolor sit amet consectetur,
                adipisicing elit. Dolores possimus, ipsum rerum labore qui eum
                amet! Iste eos adipisci, enim perspiciatis eius eligendi
                asperiores ipsum numquam quidem libero placeat doloribus?
            </p>
            <p>This policy is effective as of 2000-03-01</p>
            <h2 className="privacy-heading">Contact Us</h2>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe
                illo similique impedit cupiditate, inventore qui a illum nobis
                neque pariatur minima minus, maiores dolore veritatis aliquam!
                Nihil fugiat deserunt ShareBlock@email.com ducimus!
            </p>
        </div>
    )
}
export default PrivacyPolicyPage
